import { TextCard } from "./TextCard";

export const TextSection = ({ textData }) => {
  return (
    <div className="industry_text_content-background">
      <div className="industry_text_content">
        <section className="section-layout">
          <div className="industry_text_content-container">
            <p className="industry_text_content-question">
              Is your external data spend continuing to rise?
            </p>
            <p className="industry_text_content-question">
              Are you dealing with the complexity of multiple point solutions and API’s?
            </p>
            <p className="industry_text_content-text">
              Leverage data across multiple sources such as Experian, Equifax, Transunion, Illion,
              and more, increasing your confidence and accuracy of decisions. Simplify your fraud
              stack complexity with a single platform for all of your external data needs.
            </p>
          </div>
          <div className="industry_text_content-cards_container">
            {textData.map(item => (
              <TextCard key={item.title} {...item} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};
